import "./WorldImmigrationOffice.module.css";
import Header from "@/reusable_sections/Header";
import Booking from "./sections/Booking";
import Footer from "@/reusable_sections/Footer";
export default function WorldImmigrationOfficePage() {
  return <div>
      <Header />
      <Booking />
      <Footer />
    </div>;
}